import React from 'react';
import { Outlet } from 'react-router-dom';
import Tab, { Tab as TabType } from '../../components/ui/Tab';
import useAuthStore from '@store/authStore';
import { UserRoles, Permissions } from '@hooks/users/types';
import { hasPermission } from '@utils/index';

const InsightsAndAnalyticsLayout: React.FC = () => {
  const userRole = useAuthStore.getState().role || UserRoles.STANDARD;

  const securityTabHasPermission = hasPermission(
    userRole,
    Permissions.ADMINS_SUPPORTUSER
  );

  const tabs: TabType[] = [
    { path: '/insights-and-analytics/utilisation', label: 'Utilisation' },
    { path: '/insights-and-analytics/adoption', label: 'Adoption' },
    { path: '/insights-and-analytics/productivity', label: 'Productivity' },
  ];

  if (securityTabHasPermission) {
    tabs.push({
      path: '/insights-and-analytics/assurance',
      label: 'Assurance',
    });
  }

  return (
    <div>
      <Tab tabs={tabs} />
      <Outlet />
    </div>
  );
};

export default InsightsAndAnalyticsLayout;